<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-03-11 14:30:38
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2023-08-01 17:15:25
 * @FilePath: /wemeet-poster/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/vab/components/VabAppMain/index.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="vab-app-main">
    <section class="section">
      <VabRouterView />
    </section>
    <vab-footer />
  </div>
</template>

<script>
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'VabAppMain',
  })
</script>

<style lang="scss" scoped>
  .vab-app-main {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
    min-height: 0;
  }

  .section {
    flex: 1;
    min-height: 0;
    padding-bottom: 20px;
    overflow-y: auto;
  }
</style>
